export const classes = {
  card: 'rounded-2xl bg-white transition-width shadow-card p-6 overflow-auto',
};
